import { createSelector } from 'reselect';

const contactIds = (state) => state.contacts.ids;

export const getContactsById = (state) => state.entities.contacts;

export const getContactsIsLoading = (state) => state.contacts.isLoading;

export const getActiveContactId = (state) => state.contacts.activeContactId;

export const getEditingUserContactId = (state) => state.contacts.editingUserContactId;

export const getEditingUserContact = createSelector(
  [getContactsById, getEditingUserContactId],
  (contacts, id) => (id && contacts[id] ? contacts[id] : null),
);

export const getEditingUserContactIsLoading = (state) =>
  state.contacts.editingUserContactIsLoading;

export const getActiveContact = createSelector(
  [getContactsById, getActiveContactId],
  (contacts, id) => contacts[id],
);

export const getAllContacts = createSelector(
  [getContactsById, contactIds],
  (contacts, ids) => ids.map((id) => contacts[id]),
);

export const getContactIdsBySpaceId = (state, spaceId) =>
  state.contacts.membersBySpaceId[spaceId] || [];

export const getContactsBySpaceId = createSelector(
  [getContactsById, getContactIdsBySpaceId],
  (contacts, ids) => ids.map((id) => contacts[id]),
);

const getMyContactId = (state) => state.contacts.myContactId;

export const getMyContact = createSelector(
  [getContactsById, getMyContactId],
  (contacts, id) => ((contacts && contacts[id]) ? contacts[id] : null),
);
